import client from 'services/networking/client';

export const getFairPlayCertificate = async (): Promise<string> => {
  try {
    const { fairPlayCertificate } = await client.get('/fairplay-certificate');
    return fairPlayCertificate;
  } catch (error) {
    throw new Error(`${error.message}An error occured during retrieval of fairplay certificate`);
  }
};
